module.exports = "/images/vendor/flag-icon-css/flags/4x3/dk.svg?eb1416e02baeee91a39f721e871caf23";